/**
 * Shkallët tatimore te redaktori i politikës fiskale — një rregull i vetëm.
 *
 * Tatimi llogaritet brez për brez (`taxOn`): çdo mbivendosje tatohet dy herë,
 * çdo zbrazëtirë mbetet pa tatim. Prandaj brezat duhet të jenë një zinxhir:
 * i pari nis nga 0, secili nis aty ku mbaron i mëparshmi, dhe vetëm i fundit
 * mund të jetë «pa kufi».
 */

const n = (v) => (v === null || v === undefined || v === '' ? null : Number(v));

/** Renditja sipas «Nga». */
export const sortBrackets = (list) => [...(list || [])].sort((a, b) => (n(a.From) ?? 0) - (n(b.From) ?? 0));

/**
 * Kontrolli i zinxhirit. Kthen tekstin e gabimit të parë, ose '' kur është në rregull.
 */
export function validateBrackets(list) {
  const rows = sortBrackets(list);
  if (!rows.length) return 'Duhet të paktën një shkallë tatimore.';
  for (let i = 0; i < rows.length; i++) {
    const b = rows[i];
    const from = n(b.From), to = n(b.To), tax = n(b.Tax);
    const label = `Shkalla ${i + 1}`;
    if (tax === null || Number.isNaN(tax)) return `${label}: norma e tatimit mungon.`;
    if (tax < 0 || tax > 100) return `${label}: tatimi duhet të jetë 0–100%.`;
    if (tax > 0 && tax < 1) return `${label}: norma shkruhet në përqindje (p.sh. 8, jo 0.08).`;
    if (from === null || from < 0) return `${label}: «Nga» mungon ose është negative.`;
    if (i === 0 && from !== 0) return 'Shkalla e parë duhet të nisë nga 0 €.';
    if (i > 0) {
      const prevTo = n(rows[i - 1].To);
      if (prevTo === null) return `Vetëm shkalla e fundit mund të jetë «pa kufi» (shkalla ${i}).`;
      if (from !== prevTo) return `${label} duhet të nisë aty ku mbaron e mëparshmja (${prevTo} €).`;
    }
    if (to !== null && to <= from) return `${label}: «Deri» duhet të jetë më e madhe se «Nga».`;
  }
  return '';
}

/**
 * Shkalla e re ndan të fundit: e fundit merr një kufi (+200 € mbi fillimin e
 * saj, i redaktueshëm) dhe e reja nis aty, pa kufi. Më parë e reja niste nga 0
 * pa kufi dhe mbivendosej me të gjitha.
 */
export function addBracketAfterLast(list, makeId) {
  const rows = sortBrackets(list);
  if (!rows.length) return [{ id: makeId(), From: 0, To: null, Tax: 0, desc: '' }];
  const last = rows[rows.length - 1];
  const lastFrom = n(last.From) ?? 0;
  const cut = n(last.To) ?? lastFrom + 200;
  const updatedLast = { ...last, To: cut };
  return [...rows.slice(0, -1), updatedLast, { id: makeId(), From: cut, To: null, Tax: n(last.Tax) ?? 0, desc: '' }];
}

/**
 * Heqja e një shkalle pa lënë zbrazëtirë: e mëparshmja zgjatet deri aty ku
 * mbaronte ajo e hequr (ose bëhet «pa kufi» kur hiqet e fundit).
 */
export function removeBracketReconnect(list, isTarget) {
  const rows = sortBrackets(list);
  const idx = rows.findIndex(isTarget);
  if (idx < 0 || rows.length <= 1) return rows;
  const removed = rows[idx];
  const out = rows.filter((_, i) => i !== idx);
  if (idx > 0) out[idx - 1] = { ...out[idx - 1], To: n(removed.To) };
  else out[0] = { ...out[0], From: 0 };
  return out;
}

/** Përmbledhja e të gjitha shkallëve, jo vetëm e katër të parave. */
export function describeBrackets(list, fmt = (v) => `${v} €`) {
  return sortBrackets(list)
    .map((b) => (n(b.To) === null ? `mbi ${fmt(n(b.From) ?? 0)} → ${n(b.Tax) ?? 0}%` : `${fmt(n(b.From) ?? 0)}–${fmt(n(b.To))} → ${n(b.Tax) ?? 0}%`))
    .join('  |  ');
}
